class Globals {
  constructor() {
    this.width = 0;
    this.height = 0;
  }

  relToScreen(rel) {
    const ret = {};
    ret.x = rel.x * this.width;
    ret.y = rel.y * this.height;
    return ret;
  }

  relSizeToScreen(rel) {
    const ret = {};
    ret.x = rel.x * this.width;
    ret.y = rel.y * this.height;
    return ret;
  }

}

const globals = new Globals();

export { globals as default };
